module.exports = __webpack_public_path__ + "img/section-background.18124438.svg";